import { render } from "./payment_type_selection.vue?vue&type=template&id=033d783c"
import script from "./payment_type_selection.vue?vue&type=script&lang=js"
export * from "./payment_type_selection.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\cbetta\\Desktop\\workspace\\Developpement\\_VELO\\demo-location.accen.me\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__